
import { defineComponent } from 'vue';
import { translate } from 'CoreHome';
import IconAi from '../Icon/IconAi.vue';
import IconClose from '../Icon/IconClose.vue';
import Chat from '../Chat/Chat.vue';

export default defineComponent({
  components: {
    IconAi,
    Chat,
    IconClose,
  },
  props: {
    displayOffcanvas: { type: Boolean, default: false },
    widgetParams: { type: Object, required: true },
    aiName: { type: String, required: true },
    aiLabel: { type: String, required: true },
    aiColor: { type: String, default: '#3450a3' },
    apiMethod: { type: String, required: true },
  },
  computed: {
    insightsTitle(): string {
      return translate('ChatGPT_Insights');
    },
  },
  watch: {
    displayOffcanvas(newVal: boolean) {
      if (newVal) {
        document.addEventListener('keydown', this.handleKeydown);
      } else {
        document.removeEventListener('keydown', this.handleKeydown);
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    handleKeydown(event: KeyboardEvent) {
      if (event.key === 'Escape') {
        this.onClose();
      }
    },
    onClose() {
      this.$emit('close');
    },
    onSubmit() {
      (this.$refs.chat as InstanceType<typeof Chat>).onSubmit();
    },
  },
});
